import { API_BASE_URL, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const uploadScormPackageApi = (moduleId, contentId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("moduleId", moduleId);
    formData.append("contentId", contentId);

    return postRequest({
        url: `${API_BASE_URL}/api/scorm/packages/upload`,
        data: formData,
        token: getToken(),
        uid: getUid(),
    });
};

export const launchScormContentApi = (moduleId, contentId, scoId = null, nodeId = null) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/launch`,
        data: { scoId, nodeId },
        token: getToken(),
        uid: getUid(),
    });

export const initializeScorm = (moduleId, contentId, data) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/initialize`,
        data,
        token: getToken(),
        uid: getUid(),
    });

export const setScormValues = (moduleId, contentId, data) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/values`,
        data,
        token: getToken(),
        uid: getUid(),
    });

export const commitScorm = (moduleId, contentId, data) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/commit`,
        data,
        token: getToken(),
        uid: getUid(),
    });

export const finishScorm = (moduleId, contentId, data) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/finish`,
        data,
        token: getToken(),
        uid: getUid(),
    });

export const getScormState = (moduleId, contentId, attemptId, registrationId = null) => {
    const params = new URLSearchParams({ attemptId });
    if (registrationId) params.append("registrationId", registrationId);
    return getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/scorm/state?${params.toString()}`,
        token: getToken(),
        uid: getUid(),
    });
};

export const fetchScormPackageApi = (packageId) =>
    getRequest({
        url: `${API_BASE_URL}/api/scorm/packages/${packageId}`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchScormTreeApi = (packageId) =>
    getRequest({
        url: `${API_BASE_URL}/api/scorm/packages/${packageId}/tree`,
        token: getToken(),
        uid: getUid(),
    });
